import { put, call } from "redux-saga/effects";
import * as actions from "../actions";
import * as Api from "../../api";
import {
  addTimesheetToCache,
  getTimesheetFromCache,
} from "../../helpers/cache";
import { getStatusName } from "../../helpers/timesheets";

const isTimesheetUpdated = (timesheet) => {
  const statusName = getStatusName(
    timesheet.calculatedStatusCode,
    timesheet.rejected,
    false
  );
  return statusName === "rejected" || statusName === "approved";
};
// eslint-disable-next-line import/prefer-default-export
export function* requestTimesheetData() {
  try {
    yield put(actions.timesheetsSetIsLoading(true));
    const response = yield call(Api.getTimesheets); // FONT ENDPOINT
    const { timesheets } = response.data;
    yield put(actions.timesheetsSetData(timesheets));
  } catch (error) {
    yield put(actions.addError("timesheets", error));
  } finally {
    yield put(actions.timesheetsSetIsLoading(false));
  }
}

export function* updateTimesheet(action) {
  const { timesheet, shouldSendNotification = false } = action.payload;
  try {
    const response = yield call(
      Api.putTimesheet,
      timesheet,
      shouldSendNotification
    );
    if (response.status === 200) {
      const updatedTimesheet = response.timesheet || timesheet;
      const pendingTimesheet = {
        ...updatedTimesheet,
        calculatedStatusCode: "Z10",
        submitted: shouldSendNotification,
      };
      addTimesheetToCache(pendingTimesheet);
      yield put(actions.timesheetUpdateSuccess(pendingTimesheet));
    } else {
      yield put(actions.addError("timesheets", response));
      throw new Error(
        `Failed to update timesheet with response code: ${response.status}`
      );
    }
  } catch (error) {
    yield put(actions.addError("timesheets", error));
    yield put(actions.timesheetUpdateFailed(timesheet));
  }
}

export function* sendFeedback({ payload }) {
  const { score, timesheetNumber, comments } = payload;
  try {
    yield call(Api.sendFeedbackReq, score, comments, timesheetNumber);
  } catch (error) {
    yield put(actions.addError("timesheet-feedback", error));
  }
}
